import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { DataTypeProvider } from "@devexpress/dx-react-grid";

const ParticAnestesistaFormatter = ({ value }) => <TextField value={value == "COD" ? "Código operadora" : value} InputProps={{ disableUnderline: true }} />;

const ParticAnestesistaEditor = ({ value, onValueChange, disabled }) => {
  if (disabled) {
    return value ?? "";
  }

  return (
    <Select input={<Input />} value={value} onChange={(event) => onValueChange(event.target.value)} style={{ width: "100%" }}>
      <MenuItem value="">Selecione</MenuItem>
      <MenuItem value="CPF">CPF</MenuItem>
      <MenuItem value="COD">Código operadora</MenuItem>
    </Select>
  );
};
export const ParticAnestesistaTypeProvider = (props) => <DataTypeProvider formatterComponent={ParticAnestesistaFormatter} editorComponent={ParticAnestesistaEditor} {...props} />;
